import storageService from 'top20common/distribution/services/storage';
import companiesModule from 'top20common/distribution/store/modules/companies';
import jobModule from 'top20common/distribution/store/modules/job';
import jobsModule from 'top20common/distribution/store/modules/jobs';
import referralPotentialBonus from 'top20common/distribution/store/modules/referral-potential-bonus';
import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import getters from './getters';
import applicationsModule from './modules/applications';
import editProfileModule from './modules/edit-profile';
import payoutRequests from './modules/payout-requests';
import profileModule from './modules/profile';
import questionnaireModule from './modules/questionnaire';
import recommendedJobsModule from './modules/recommended-jobs';
import referralsModule from './modules/referrals';
import tokensModule from './modules/tokens';
import mutations from './mutations';
import state from './state';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    candidateProfileState: profileModule,
    jobsState: jobsModule,
    jobState: jobModule,
    recommendedJobsState: recommendedJobsModule,
    companiesState: companiesModule,
    applicationsState: applicationsModule,
    referralsState: referralsModule,
    tokensState: tokensModule,
    editProfileState: editProfileModule,
    questionnaireState: questionnaireModule,
    referralPotentialBonusState: referralPotentialBonus,
    payoutRequestsState: payoutRequests
  },
  plugins: [storageService.getCommonStorage().plugin]
});
